export function fileToBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result); // Includes the data: URI prefix
    };

    reader.onerror = error => {
      reject(error);
    };

    reader.readAsDataURL(file); // Encodes the file as a base64 string
  });
}
